import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useGetSingleUserQuery } from "../../../features/portal/user/userApi";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { employeeDetailsList } from "./EmployeesDetails";
import CircularProgressBar from "./_components/edit/CircularProgressBar";
import EmergencyInfo from "./_components/edit/EmergencyInfo";
import FinancialInfo from "./_components/edit/FinancialInfo";
import Item from "./_components/edit/Item";
import OfficialInfo from "./_components/edit/OfficialInfo";
import PersonalInfo from "./_components/edit/PersonalInfo";
import UserAccessPermission from "./_components/edit/UserAccessPermission";
import { calculateDetailsPercentage } from "./_components/edit/utils";

type ItemType = (typeof employeeDetailsList)[number];

export default function EditEmployees() {
  const { editId } = useParams();
  const [percentage, setPercentage] = useState(0);
  let [queryParams, setSearchParams] = useSearchParams();
  const [item, setItem] = useState<ItemType | number>("Official");
  const { data: getEmployeeData } = useGetSingleUserQuery(editId || "", {
    skip: !editId,
  });
  // const { isLoading, isError, error, data } = useGetAdditionalDataQuery({});
  // const {
  //   isError: isSalaryError,
  //   error: salaryError,
  //   data: salaryData,
  // } = useGetEmployeeBreakdownSalaryDetailsQuery(editId || "", {
  //   skip: !editId,
  // });
  // const payrollSetting = salaryData?.data?.salary_info;
  // const {
  //   isError: isAdditionalError,
  //   error: additionalError,
  //   data: additionalData,
  // } = useGetEmployeeAdditionalFieldsQuery({
  //   params: { skip: 0, limit: 0 },
  // });
  // useError(
  //   isAdditionalError,
  //   additionalError,
  //   "Get additional information fail"
  // );
  // useError(isError, error, "Get additional data fail");
  // useError(isSalaryError, salaryError, "Get salary setting fail");

  const employee = getEmployeeData?.data;
  // console.log(employee);

  function getInfoData() {
    if (item === "Official") {
      return <OfficialInfo />;
    } else if (item === "Personal") {
      return <PersonalInfo />;
    } else if (item === "Financial") {
      return <FinancialInfo />;
    }
    // else if (item === "Salary") {
    //   return <SalaryInfo />;
    // }
    else if (item === "Emergency") {
      return <EmergencyInfo />;
    }
    //  else if (checkAddition(item)) {
    //   return <AdditionalInfo />;
    // }
    else if (item === "User Access Permission") {
      return <UserAccessPermission />;
    } else {
      return undefined;
    }

    // function checkAddition(value: ItemType | number) {
    //   const itemData = Number(value);
    //   return !isNaN(itemData);
    // }
  }

  useEffect(() => {
    if (queryParams.get("type")) {
      setItem(queryParams.get("type") as ItemType);
    }
  }, [queryParams]);

  // const payRoll = payrollSetting?.breakdown_percentage?.length
  //   ? payrollSetting?.breakdown_percentage
  //       ?.filter((item) => item?.is_active)
  //       ?.map((item) => ({
  //         ...item,
  //         amount: item?.amount || undefined,
  //       }))
  //   : payrollSetting?.global_gross_salary_component
  //       ?.filter((item) => item?.is_active)
  //       ?.map((item) => ({
  //         ...item,
  //         amount: undefined,
  //       }));

  // const payrollObject = payRoll?.reduce((acc, item) => {
  //   acc[item.id] = item.amount;
  //   return acc;
  // }, {});

  const detailsData = {
    Official: {
      name: employee?.name,
      username: employee?.username,
      email: employee?.email,
      department_id: employee?.department?.id,
      business_role_id: employee?.sub_department_id,
      join_date: employee?.join_date,
      manager_id: employee?.manager_id,
      employee_id: employee?.employee_id,
      grade: employee?.grade,
      employee_type: employee?.employee_type,
    },
    Personal: {
      gender: employee?.member?.profile?.gender,
      mobile: employee?.mobile,
      dob: employee?.member?.profile?.dob,
      address: employee?.member?.profile?.address,
      nationality: employee?.member?.profile?.nationality,
      nid_no: employee?.member?.profile?.nid_no,
      nid_image_back: employee?.member?.profile?.nid_image_back,
      nid_image_front: employee?.member?.profile?.nid_image_front,
      passport_no: employee?.member?.profile?.passport_no,
      passport_image: employee?.member?.profile?.passport_image,
      blood_group: employee?.member?.profile?.blood_group,
      social_links: {
        facebook: employee?.member?.social_links?.facebook,
        instagram: employee?.member?.social_links?.instagram,
        linkedIn: employee?.member?.social_links?.linkedin,
      },
    },
    Financial: {
      tin_no: employee?.member?.profile?.tin_no,
      tin_certificate: employee?.member?.profile?.tin_certificate,
      bank_info: employee?.member?.profile?.bank_info?.length,
    },
    // Salary: {
    //   salary: payrollSetting?.global_gross_salary_component,
    //   ...payrollObject,
    // },
    Emergency: {
      emergency_contract_person_name:
        employee?.member?.emergency_contract_person_name,
      emergency_contract_person_number:
        employee?.member?.emergency_contract_person_number,
      emergency_contract_person_relationship:
        employee?.member?.emergency_contract_person_relationship,
    },
    // Additional: {
    //   currentData: employee?.additional_data?.length,
    //   allData: {
    //     additionalFields: new Array(
    //       additionalData?.data?.additionalFields?.length
    //     ),
    //   },
    // },
    "User Access Permission": {
      abc: true,
    },
  };

  // console.log(detailsData);

  const totalData = calculateDetailsPercentage(detailsData);

  useEffect(() => {
    const avgData =
      Object.values(totalData).reduce((acc, curr) => acc + curr, 0) /
      Object.values(totalData).length;
    setPercentage(Math.round(avgData || 0));
  }, [totalData]);

  return (
    <SidebarLayout title="Edit Employees">
      <div className="grid md:grid-cols-3 gap-6">
        <div className="bg-white rounded-md p-6 border border-extra-light">
          <div className="flex justify-center items-center">
            <CircularProgressBar percentage={percentage} />
          </div>
          <p className="mt-4 mb-6 text-center text-display-body">
            Complete employee profile for better usage
          </p>

          <ul className="flex flex-col gap-2.5">
            {employeeDetailsList.map((el, index) => (
              <Item
                key={el}
                onClick={() => {
                  setItem(el);
                  setSearchParams({ type: el });
                }}
                active={item === el}
                completed={totalData?.[el] >= 80}
                index={index}
              >
                {el}
              </Item>
            ))}
            {/* {isLoading ? (
              <li className="text-center py-1 text-body">Loading...</li>
            ) : (
              data?.data?.additionalSections?.map((el, index) => (
                <Item
                  key={el?.id}
                  onClick={() => {
                    setItem(el?.id);
                    setSearchParams({ type: el?.id?.toString() });
                  }}
                  active={item?.toString() === el?.id?.toString()}
                  completed={totalData?.Additional >= 80}
                  index={employeeDetailsList?.length + index}
                >
                  {el?.label}
                </Item>
              ))
            )} */}
          </ul>
        </div>

        <div className="bg-white md:col-span-2 rounded-md p-6 border border-extra-light">
          {getInfoData()}
        </div>
      </div>
    </SidebarLayout>
  );
}
